import { render } from "./WorkflowNotes.vue?vue&type=template&id=1948fd8a"
import script from "./WorkflowNotes.vue?vue&type=script&lang=js"
export * from "./WorkflowNotes.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alpha/Documents/IONS/project/pit-story/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__